import React from 'react';
import FormStep from "../form-step";
import {Field, Form} from "formik";
import {renderField} from "../../../../utils/form-utils";
import * as Yup from "yup";
import ActionButtons from "../action-buttons";
import StepLayout from "../step-layout";

const validationSchema = Yup.object().shape({
    firstname: Yup.string().required('Required'),
    lastname: Yup.string().required('Required'),
    salutation: Yup.string().required('Required'),
    company: Yup.string().required('Required'),
    phone: Yup.string().required('Required'),
    email: Yup.string().email('Invalid email').required('Required'),
});

const ContactInfo = ({data, onNext, customErrors}) => {
    const initialValues = {
        firstname: data.firstname || '',
        lastname: data.lastname || '',
        salutation: data.salutation || '',
        company: data.company || '',
        phone: data.phone || '',
        email: data.email || '',
    };

    return (
        <FormStep
            name="Contact Info"
            initialValues={initialValues}
            validationSchema={validationSchema}
            onNext={onNext}
        >
            <StepLayout actions={<ActionButtons />}>
                {customErrors.length > 0 && <div style={{textAlign: 'center', display: 'block'}} className="invalid-feedback">{customErrors.map(e => <p style={{marginBottom: '0'}} key={e}>{e}</p>)}</div>}
                <Field
                    type="text"
                    name="firstname"
                    component={renderField}
                    label="Firstname"
                />
                <Field
                    type="text"
                    name="lastname"
                    component={renderField}
                    label="Lastname"
                />
                <Field
                    type="text"
                    name="salutation"
                    component={renderField}
                    label="Title"
                />
                <Field
                    type="text"
                    name="company"
                    component={renderField}
                    label="Company"
                />
                <Field
                    type="text"
                    name="phone"
                    component={renderField}
                    label="Phone"
                />
                <Field
                    type="text"
                    name="email"
                    component={renderField}
                    label="Email"
                />
            </StepLayout>
        </FormStep>
    )
}

export default ContactInfo;